import { type SystemToastProps } from '@wellesley/system-toast'
import { sendMessage } from '../../../common/message/sendMessage'
import { showToastMessageAction } from './actions'
import { listenMessage } from '../../../common/message/listenMessage'
import {
  clickOnToastButtonAction,
  closeToastAction,
  type ClickOnToastButtonAction,
  dismissToastAction,
} from './actions'
import { ID } from '../helpers/createIDAction'

const currentOpenToast = new Set<ID>()
const toastUnsubscribers = new Map<ID, () => void>()

export const dismissToast = (toastId: string | number) => {
  sendMessage({
    action: dismissToastAction({ toastId }),
  })
}

export const showToastMessage = (props: SystemToastProps) => {
  const {
    options,
    toast: { type, title },
  } = props

  const toastId = options?.id || `${type}:${title}`

  const unsubscribeToast = () => {
    toastUnsubscribers.get(toastId)?.()
    toastUnsubscribers.delete(toastId)
  }

  if (currentOpenToast.has(toastId)) {
    unsubscribeToast()
  }
  currentOpenToast.add(toastId)

  sendMessage({
    action: showToastMessageAction(toastId, props),
  })

  const unsubscribe = listenMessage<ClickOnToastButtonAction>({
    whitelist: [clickOnToastButtonAction, closeToastAction],
    onMessage: (action) => {
      if (action.id === toastId) {
        clickOnToastButtonAction.match(action) &&
          options?.actionButton?.onClick()

        currentOpenToast.delete(toastId)
        unsubscribeToast()
      }
    },
  })
  toastUnsubscribers.set(toastId, unsubscribe)
}
